import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ProductProvider } from "@/lib/product";
import Home from "@/pages/Home";
import MentionsLegales from "@/pages/MentionsLegales";
import Cgv from "@/pages/Cgv";
import Privacy from "@/pages/Privacy";
import OrderConfirmed from "@/pages/OrderConfirmed";
import OrderCancelled from "@/pages/OrderCancelled";
import Admin from "@/pages/Admin";
import ReviewPage from "@/pages/ReviewPage";
import CharteAvis from "@/pages/CharteAvis";
import ResumeOrder from "@/pages/ResumeOrder";
import Unsubscribe from "@/pages/Unsubscribe";
import ResetPassword from "@/pages/ResetPassword";
import { CookieBanner } from "@/components/CookieBanner";
import { MetaRouteTracker } from "@/components/MetaRouteTracker";

function App() {
  return (
    <ProductProvider>
      <BrowserRouter>
        <CookieBanner />
        <MetaRouteTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgv" element={<Cgv />} />
          <Route path="/politique-confidentialite" element={<Privacy />} />
          <Route path="/commande/confirmee" element={<OrderConfirmed />} />
          <Route path="/commande/annulee" element={<OrderCancelled />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/reinitialiser/:token" element={<ResetPassword />} />
          <Route path="/avis/:token" element={<ReviewPage />} />
          <Route path="/charte-des-avis" element={<CharteAvis />} />
          <Route path="/reprendre/:token" element={<ResumeOrder />} />
          <Route path="/desabonnement/:token" element={<Unsubscribe />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </ProductProvider>
  );
}

export default App;
